<app-header [hidePhone]="true" [hidePortal]="true" [largeDesktopLogo]="true" [logoUrl]="'/'">
  <!-- <ng-container customHeader> -->
  <!-- Sign-in and Sign-out Actions -->

  <!-- <ng-container @if="!(isLoggedIn$ | async); else signOut">
      <button
        mat-button
        #menuTrigger="matMenuTrigger"
        matTooltip="Sign in"
        matTooltipClass="offset-down"
        [matMenuTriggerFor]="login"
        class="header-button"
        @if="!(isMobile$ | async)"
      >
        <fa-icon [icon]="['fas', 'user-circle']"></fa-icon>
        <span class="button-text">Contractor Sign-In</span>
      </button> -->

  <!-- mobile button -->
  <!-- <button
        #menuTrigger="matMenuTrigger"
        matTooltip="Sign in"
        matTooltipClass="offset-down"
        [matMenuTriggerFor]="login"
        class="header-icon"
        @if="isMobile$ | async"
      >
        <div class="hover-effect"></div>
        <fa-icon [icon]="['fas', 'user-circle']"></fa-icon>
      </button> -->

  <!-- DROPDOWN MENU -->
  <!-- <mat-menu
        #login="matMenu"
        [overlapTrigger]="true"
        xPosition="before"
        class="mat-menu-login"
      >
        <app-login
          [isLoginLoading]="isLoginLoading$ | async"
          (signin)="signIn($event)"
        ></app-login>
      </mat-menu>
    </ng-container> -->

  <!-- signout button icon-->
  <!-- <ng-template #signOut>
      <button
        mat-button
        class="header-button"
        (click)="logOut()"
        @if="!(isMobile$ | async)"
      >
        <fa-icon [icon]="['fas', 'sign-out']"></fa-icon>
        <span class="button-text">Sign Out</span>
      </button> -->

  <!-- mobile icon -->
  <!-- <button class="header-icon" (click)="logOut()" @if="isMobile$ | async">
        <div class="hover-effect"></div>
        <fa-icon [icon]="['fas', 'sign-out']"></fa-icon>
      </button>
    </ng-template>
  </ng-container> -->
</app-header>
